import { Component, Input } from '@angular/core';

@Component({
  selector: 'user-status-blocks',
  template: require('./user.status-blocks.component.html')
})
export class UserStatusBlocksComponent {
  @Input() user: any;

  constructor() {}
}
